import React from 'react';
import './index.scss';
import { Checkbox } from 'antd';
import classNames from 'classnames';

interface CheckboxProps {
  label?: string;
  classname?: string;
  styles?: React.CSSProperties;
  // onCheck?: () => void;
}

export function Check({ label, classname, styles }: CheckboxProps) {
  const avatarStyle = {
    ...styles,
  };
  const classes = classNames('checkbox', classname);
  // const onChange = () => {
  //   onCheck();
  // };

  return (
    <div className={classes} style={avatarStyle}>
      <Checkbox style={{}}>{label}</Checkbox>
    </div>
  );
}

Check.defaultProps = {
  label: 'Click to check',
};

export default React.memo(Check);
